import React from "react";

const Tag = (props: any) => {
  return (
    <svg width={18} height={18} fill="none" {...props}>
      <path
        fill="var(--color-icon-bright)"
        d="M9.052 16.485a4.134 4.134 0 0 1-2.925-1.207L2.73 11.88a4.161 4.161 0 0 1-1.208-3.127l.18-3.75a3.456 3.456 0 0 1 3.3-3.3l3.75-.18A4.19 4.19 0 0 1 11.88 2.73l3.397 3.398a4.151 4.151 0 0 1 0 5.857l-3.292 3.293a4.152 4.152 0 0 1-2.933 1.207Zm-5.527-5.407 3.397 3.397c.57.57 1.328.885 2.13.885.803 0 1.56-.315 2.13-.885l3.293-3.292c.57-.57.885-1.328.885-2.13 0-.803-.315-1.56-.885-2.13l-3.398-3.398c-.6-.6-1.432-.922-2.272-.877l-3.75.18a2.32 2.32 0 0 0-2.235 2.22l-.18 3.75c-.038.847.285 1.68.885 2.28Z"
      />
      <path
        fill="var(--color-icon-bright)"
        d="M7.125 9.563a2.442 2.442 0 0 1-2.438-2.438 2.442 2.442 0 0 1 2.438-2.438 2.442 2.442 0 0 1 2.438 2.438 2.442 2.442 0 0 1-2.438 2.438Zm0-3.75c-.72 0-1.313.592-1.313 1.312 0 .72.593 1.313 1.313 1.313s1.313-.593 1.313-1.313-.593-1.313-1.313-1.313Z"
      />
    </svg>
  );
};

export default Tag;
